import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Text } from '@fluentui/react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { ReactTemplate } from '@bingads-webui-react/react-template';

import { getBulletItemStyles, bulletItemStyles } from './styles';

export const BulletItem = (props) => {
  const {
    text,
    renderIcon,
  } = props;

  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getBulletItemStyles);

  return (
    <div className={classNames('bullet-item', classes.bulletItem)}>
      {renderIcon &&
        <div className={classNames('icon-container', classes.iconContainer)}>
          {renderIcon()}
        </div>
      }
      <Text
        variant="medium"
        block
        styles={bulletItemStyles.text}
      >
        <ReactTemplate
          model={{ bold: t => <b>{t}</b> }}
          template={i18n.getString(text)}
        />
      </Text>
    </div>
  );
};

BulletItem.propTypes = {
  renderIcon: PropTypes.string,
  text: PropTypes.string.isRequired,
};

BulletItem.defaultProps = {
  renderIcon: undefined,
};
